import { Injectable, AfterViewInit } from '@angular/core';
import { L10n } from '@syncfusion/ej2-base';
import { StorageManagerService } from './storage-manager.service';

@Injectable()
export class GridPreferencesService implements AfterViewInit {
  filterSettings = {};

  constructor(private storageManagerService: StorageManagerService) { }

  ngAfterViewInit() {
    this.loadLocalizationSettings();
  }

  loadLocalizationSettings() {
    const isBncc = document.getElementById('bnccEstablishmentEditAlert');
    if (isBncc) {
      L10n.load({
        'en-US': {
          grid: {
            CancelButton: 'Cancel',
            OKButton: 'OK'
          }
        }
      });
    } else {
      L10n.load({
        'en-US': {
          grid: {
            CancelButton: 'Cancel',
            OKButton: 'Apply',
          }
        }
      });
    }
  }

  onGridPreferencesSave(pageName, gridId, gridReference, event) {
    if (event.requestType === 'filtering' || event.requestType === 'refresh') {
      return;
    }

    this.filterSettings[pageName] = {};
    this.filterSettings[pageName][gridId] = [...gridReference.filterSettings.columns];

    gridReference.clearFiltering();
    const userguid = this.storageManagerService.read('userData').userguid;
    let colsObject = [];

    gridReference.columns.map(column => {
      if (column.headerText) {
        colsObject.push({ headerText: column.headerText });
      }
      return column;
    });
    let gridPrefenceSettings: any = localStorage.getItem('gridPrefenceSettings' + userguid);
    gridPrefenceSettings = gridPrefenceSettings ? JSON.parse(gridPrefenceSettings) : {};
    gridPrefenceSettings[pageName] = gridPrefenceSettings[pageName] ?? {};
    gridPrefenceSettings[pageName][gridId] = { settings: gridReference.getPersistData(), columns: colsObject };

    localStorage.setItem('gridPrefenceSettings' + userguid, JSON.stringify(gridPrefenceSettings));

    if (this.filterSettings[pageName] && this.filterSettings[pageName][gridId]) {
      gridReference.filterSettings.columns = this.filterSettings[pageName][gridId];
    }
  }

  onGridPreferencesRestore(pageName, gridId, gridReference) {
    const userguid = this.storageManagerService.read('userData').userguid;
    let gridPrefenceSettings: any = localStorage.getItem('gridPrefenceSettings' + userguid);
    if (gridPrefenceSettings) {
      gridPrefenceSettings = JSON.parse(gridPrefenceSettings);

      if (gridPrefenceSettings[pageName] && gridPrefenceSettings[pageName][gridId]) {
        this.restoreHandler(pageName, gridId, gridReference, gridPrefenceSettings[pageName][gridId].settings);
      }
    }
  }

  checkboxClick(grid_ref, disabledColumns) {
    setTimeout(function (e) {
      const dialogContents = document.getElementsByClassName('e-dlg-content')[0];
      let sortedUL = dialogContents.querySelectorAll('ul')[0];

      grid_ref.columnModel.forEach((column, index) => {
        if (disabledColumns) {
          let disabledColumn = disabledColumns.find(x => x === column.headerText);
          if (disabledColumn) {
            this.addElement(sortedUL, disabledColumn, index);
          }
        }
      });
    }.bind(this));
  }

  addElement(parentElement, textContent, position) {
    let li = document.createElement("li");
    let div = document.createElement("div");
    div.setAttribute("class", "e-ccheck");
    let wrapperDiv = document.createElement("div");
    wrapperDiv.setAttribute("class", "e-checkbox-wrapper e-css e-checkbox-disabled");
    let box = document.createElement("span");
    box.setAttribute("class", "e-icons e-check custom-checkbox-chooser");
    let span = document.createElement("span");
    span.setAttribute("class", "e-label");
    span.appendChild(document.createTextNode(textContent));
    wrapperDiv.appendChild(box);
    wrapperDiv.appendChild(span);
    div.appendChild(wrapperDiv);
    li.appendChild(div);
    li.setAttribute("class", "e-cclist e-cc");
    parentElement.insertBefore(li, parentElement.childNodes[position]);
  }

  restoreHandler(pageName, gridId, grid, settings) {
    let savedProperties = JSON.parse(settings);
    let gridColumnsState = Object.assign([], grid.getColumns());

    savedProperties.columns.forEach(function (col: any) {
      const headerText = gridColumnsState.find(function (colColumnsState: any) { return colColumnsState.field === col.field; })['headerText'];
      const colTemplate = gridColumnsState.find(function (colColumnsState: any) { return colColumnsState.field === col.field; })['template'];
      const headerTemplate = gridColumnsState.find(function (colColumnsState: any) { return colColumnsState.field === col.field; })['headerTemplate'];
      col.headerText = headerText;
      col.template = colTemplate;
      col.headerTemplate = headerTemplate;
    });
    if (this.filterSettings[pageName] && this.filterSettings[pageName][gridId]) {
      grid.filterSettings.columns = this.filterSettings[pageName][gridId];
    }

    grid.setProperties(savedProperties);
  }
}
